/**
 * Modules hidden from ALL navigation (Main sidebar, Developer/Super-Admin module
 * lists, dashboards, quick actions) while their code, routes, components and
 * database tables stay fully intact.
 *
 * ♻️  To REACTIVATE a module later, simply remove its id from this array — no
 *    other code changes are needed.
 */
export const HIDDEN_MODULES = ['analytics', 'vidange'];

export const isHiddenModule = (id) => HIDDEN_MODULES.includes(id);
